import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, children, className }) {
  return (
    <div className={cn("mb-6 flex flex-wrap items-end justify-between gap-4", className)}>
      <div>
        <h1 className="font-heading text-[28px] font-semibold tracking-tight sm:text-[32px]">{title}</h1>
        {subtitle && <p className="mt-1 text-[15px] text-muted-foreground">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="card-surface flex flex-col items-center justify-center px-6 py-16 text-center">
      {Icon && (
        <div className="mb-4 grid h-14 w-14 place-items-center rounded-full bg-[#33B6E4]/10 text-[#33B6E4]">
          <Icon className="h-6 w-6" />
        </div>
      )}
      <h3 className="font-heading text-[18px] font-semibold">{title}</h3>
      {description && <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Phase2({ icon: Icon, title, note }) {
  return (
    <div>
      <PageHeader title={title} />
      <EmptyState
        icon={Icon}
        title="Coming in Phase 2"
        description={note}
      />
    </div>
  );
}
